module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8a062193779ce87c1c79f9ac307ac681.png";